<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.71,12.29C13.71,12.29,5.41,4,5.41,4C5.41,4,10,4,10,4C10.55,4,11,3.55,11,3C11,2.45,10.55,2,10,2C10,2,3,2,3,2C2.45,2,2,2.45,2,3C2,3,2,10,2,10C2,10.55,2.45,11,3,11C3.55,11,4,10.55,4,10C4,10,4,5.41,4,5.41C4,5.41,12.29,13.7,12.29,13.7C12.47,13.89,12.72,14,13,14C13.55,14,14,13.55,14,13C14,12.72,13.89,12.47,13.71,12.29C13.71,12.29,13.71,12.29,13.71,12.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'ArrowTopLeft',
} as DefineComponent
</script>
